import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { AccountSearchDispatcher } from "./Variable";

export interface AccountSearchStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class AccountSearchStatic extends BaseStore<AccountSearchStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AccountSearchDispatcher, (actionData) => this.onAccountSearchStoreResponse(actionData));
    }

    public getLastResult(): AccountSearchStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): AccountSearchStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onAccountSearchStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, data: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}